import React from 'react';
import { makeAutoObservable } from 'mobx';
import { makePersistable, clearPersistedStore, isPersisting, isHydrated } from 'mobx-persist-store';

import { TProfile } from 'src/types/profiles/profile.model';

// export interface IAppStore {
//   userToken: string;
//   refreshToken: string;
//   profile: TProfile;
//   expire: string;
//   currentEmail?: string;
//   appInfos?: string;
//   updateProfile: (data: TProfile) => void;
//   updateCurrentEmail: (value?: string) => void;
//   updateUserToken(token: string, refreshToken: string, expires_in: string): Promise<void>;
//   clearPersistedData(): Promise<void>;
// }

// export class AppStore implements IAppStore {
export class AppStore {
  userToken = '';
  refreshToken = '';
  profile: TProfile = {};
  expire = '';
  currentEmail?: string = '';
  appInfos?: string = '';
  currentLanguage = 'en';

  constructor() {
    makeAutoObservable(this);

    // Now makePersistable only needs `name` and `properties`:
    makePersistable(
      this,
      {
        name: 'AppStore',
        properties: ['userToken', 'refreshToken', 'profile', 'expire', 'appInfos', 'currentLanguage'],
        storage: window.localStorage,
        stringify: true,
        debugMode: false
      },
      { delay: 0 }
    );
  }

  //#region mobx-persist-store

  get isHydrated() {
    return isHydrated(this);
  }

  get isPersisting() {
    return isPersisting(this);
  }

  async clearPersistedData(): Promise<void> {
    await clearPersistedStore(this);
    localStorage.clear();
    this.profile = {};
  }

  async updateUserToken(token: string, refreshToken: string, expires_in: string): Promise<void> {


    this.userToken = token;
    this.refreshToken = refreshToken;
    this.expire = expires_in;
  }
  //#endregion

  updateProfile(data: TProfile) {
    this.profile = { ...this.profile, ...data };
  }

  updateCurrentEmail(value?: string) {
    this.currentEmail = value;
  }

  updateAppInfo(value?: string) {
    this.appInfos = value;
  }

  updateLanguage(language: string) {
    this.currentLanguage = language;
  }
}

export const appStore = new AppStore();

export const AppStoreContext = React.createContext(appStore);
export const useAppStore = () => React.useContext(AppStoreContext);
